import * as React from "react";

/**
 * Hook providing a stable identity object containing the latest values. These
 * values should **not** be accessed during render time.
 * @param values Object containing all values.
 * @returns Stable identity object containing said values.
 */
export function useLatestValues<T extends Record<keyof T, unknown>>(
  values: T,
): T {
  const valuesRef = React.useRef<T>({} as T);
  Object.assign(valuesRef.current, values);
  return valuesRef.current;
}
